<template>
    <div class="biz-recomand">
        <div class="landing-container wrap">
            <div class="recomand">
                <div class="shot">
                    <img src="@/assets/img/landingPage/shot/2.svg" alt="">
                </div>
                <div class="info">
                    <div class="stars">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                    </div>
                    <div class="name">
                        誠毅物業管理顧問股份有限公司
                    </div>
                    <div class="description">
                        這是第一個使用過後，最貼近我們想要的系統，符合短期月租的需求。飛豬管家與我們公司理念有很多相近之處，都是希望提供全新的服務模式，期許這系統能越來越好用！
                    </div>
                </div>
            </div>
            <div class="recomand">
                <div class="shot">
                    <img src="@/assets/img/landingPage/shot/4.svg" alt="">
                </div>
                <div class="info">
                    <div class="stars">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                    </div>
                    <div class="name">
                        皇嘉物業管理股份有限公司
                    </div>
                    <div class="description">
                        很高興成為首批加入使用的企業，飛豬管家刊登廣告滿簡單的，而且免費，也可以在房客退租後銜接上新的房客，不會產生空窗期！而且報表功能很強大，非常好用！
                    </div>
                </div>
            </div>
            <div class="recomand">
                <div class="shot">
                    <img src="@/assets/img/landingPage/shot/7.svg" alt="">
                </div>
                <div class="info">
                    <div class="stars">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                        <img src="@/assets/img/landingPage/bussiness/star_gold.svg" alt="">
                    </div>
                    <div class="name">
                        家成物業管理顧問公司
                    </div>
                    <div class="description">
                        像是免費幫自己公司架設了一個推廣網站，功能滿齊全的，重要的是提前出租的效果，讓公司大大降低成本管銷支出！值得分享推薦！
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return{
        }
    },
    methods: {
       
    }
}
</script>
<style lang="scss" scoped>
    .biz-recomand{
        display: none;
        background-color:#f7f7f7;
        justify-content: center;
        .wrap{
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 85px 0;
            .recomand{
                display: flex;
                align-items: center;
                .shot{
                    width: 158px;
                    height: 158px;
                    border-radius: 50%;
                    // background: #000;
                    margin-right: 30px;
                    img{
                        width: 158px;
                        height: 158px;
                    }
                }
                .info{
                    width: 290px;
                    .stars{
                        margin-bottom: 10px;
                    }
                    .name{
                        font-size: 24px;
                        font-weight: 500;
                        color: #353535;
                        margin-bottom: 10px;
                    }
                    .description{
                        font-size: 16px;
                        color: #353535;
                        line-height: 1.5;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .biz-recomand{
            display: flex;
            .wrap{
                flex-direction: column;
                padding: 35px 15px 0 15px;
                .recomand{
                    display: flex;
                    align-items: center;
                    margin-bottom: 40px;
                    .shot{
                        width: 78px;
                        height: 78px;
                        margin-right: 23px;
                        img{
                            width: 78px;
                            height: 78px;
                        }
                    }
                    .info{
                        width: 65%;
                        .stars{
                            margin-bottom: 4px;
                            >img{
                                width: 14px;
                            }
                        }
                        .name{
                            font-size: 18px;
                        }
                        .description{
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/officailPage/bussiness/recomand.vue